import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import "media-chrome";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// --------------------------------------------------
// Fachbereiche Animation
// --------------------------------------------------

let fachbereiche = document.querySelector('.fachbereiche');

if(fachbereiche) {

  gsap.fromTo('.fachbereiche__item', {
    autoAlpha: 0,
    y: 40
  }, {
    autoAlpha: 1,
    y: 0,
    stagger: .1,
    ease: 'power1.out',
    scrollTrigger: {
      trigger: fachbereiche,
      start: 'top 75%',
      end: 'top center',
      toggleActions: 'play none none reverse',
    }
  })

}

// --------------------------------------------------
// Latest Articles Animation
// --------------------------------------------------

let latestArticles = document.querySelector('.latest-articles');

if(latestArticles) {

  gsap.fromTo('.latest-articles__item', {
    autoAlpha: 0,
    y: 40
  }, {
    autoAlpha: 1,
    y: 0,
    stagger: .1,
    ease: 'power1.out',
    scrollTrigger: {
      trigger: latestArticles,
      start: 'top 75%',
      end: 'top center',
      toggleActions: 'play none none reverse',
    }
  })

}

// --------------------------------------------------
// 🐥 Chicken
// --------------------------------------------------

let chicken = document.querySelector('.chicken');
let chickenClosed = sessionStorage.getItem('chicken-closed');

if(chicken && document.body.classList.contains('t_fachbereiche')) {

  let closeButton = document.querySelector('.chicken__close');
  let text = document.querySelector('.chicken__text');

  gsap.set([text, closeButton], {
    autoAlpha: 0,
  })

  gsap.set(chicken, {
    autoAlpha: 1,
    rotate: 20,
    transformOrigin: 'bottom',
    yPercent: 200
  })

  let chickenAnimation = gsap.timeline({
    paused: true,
    delay: 1
  })
  .to(chicken, {
    yPercent: 0,
    rotate: 0,
    ease: 'power4.out',
    duration: 1,
  })
  .fromTo(text, {
    autoAlpha: 0,
    scale: 0,
    transformOrigin: 'bottom right'
  }, {
    autoAlpha: 1,
    scale: 1,
    ease: 'back.out(1.1)',
  }, '+=.25')
  .to(closeButton, {
    autoAlpha: 1,
    ease: 'power1.inOut',
  })

  window.addEventListener('load', function() {
    if(!chickenClosed) {
      chickenAnimation.play()
    }
  })

  closeButton.addEventListener('click', function(e) {
    sessionStorage.setItem('chicken-closed', true);
    chickenAnimation.timeScale(3).reverse()
    e.preventDefault();
  })

}

// --------------------------------------------------
// 🧸 Benefits
// --------------------------------------------------

let benefits = document.querySelectorAll('.benefit');
let benefitsViewport = document.querySelector('.benefits__viewport');
if(benefits.length) {

  gsap.fromTo(benefitsViewport, {
    x: 100
  },
  {
    x: 0,
    ease: 'power1.out',
    scrollTrigger: {
      trigger: benefitsViewport,
      start: 'top bottom',
      end:  'bottom bottom',
      scrub: 1,
    }
  })
  
  function goTo(benefit) {
    if(!gsap.isTweening(benefitsViewport)) {  
      gsap.to(benefitsViewport, {
        duration: .5,
        ease: 'power1.inOut',
        scrollTo: benefit
      })
    }
  }

  benefitsViewport.addEventListener('click', function() {
    document.querySelector('.benefits__arrow--right').dispatchEvent(new Event('click'));
  })

  document.querySelector('.benefits__arrow--left').addEventListener('click', function() {
    let activeBenefit = document.querySelector('.benefit--active');
    if(activeBenefit) {
      let prevBenefit = activeBenefit.previousElementSibling || benefitsViewport.lastElementChild;
      goTo(prevBenefit);
    }
  })

  document.querySelector('.benefits__arrow--right').addEventListener('click', function() {
    let activeBenefits = document.querySelectorAll('.benefit--active');
    let lastActiveBenefit = activeBenefits[activeBenefits.length - 1];
    let nextActiveBenefit = lastActiveBenefit.nextElementSibling;

    if(nextActiveBenefit) {
      goTo(nextActiveBenefit);
    }
    else {
      goTo(benefitsViewport.firstElementChild);
    }

  })

  // Active benefits
  benefits.forEach(benefit => {

    ScrollTrigger.create({
      trigger: benefit,
      start: 'left right',
      end: 'right left',
      horizontal: true,
      scroller: benefitsViewport,
      onToggle: function(self) {
        if(self.isActive) {
          benefit.classList.add('benefit--active');
        }
        else {
          benefit.classList.remove('benefit--active');
        }
      },
    })
  
  })

}

// --------------------------------------------------
// Old time 🦕
// --------------------------------------------------

$(document).ready(function () {

  $(".navi a.a_suche").on('click', function () {
    $('header').addClass('search_open');
    $('.search input').get(0).focus();
    document.addEventListener("keyup", function (e) {
      if (e.key === "Escape") {
        $('header').removeClass('search_open');
        $('.search input').get(0).blur();
      }
    });
    return false;
  });

  function checkEmpty() {
    if ($(".modules .module:visible").length) {
      $(".empty").hide();
    }
    else {
      $(".empty").show();
    }
  }

  jQuery.expr[':'].contains = function (a, i, m) {
    return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
  };

  $(".filter_search input").on('input', function () {
    eingabe = $(this).val();
    $("a.tag").removeClass("is_active");
    if (eingabe != "") {
      $('.intronav').addClass('has_tag');
      $(".module").addClass("filtered");
      $(".module:contains('" + eingabe.toLowerCase() + "')").removeClass("filtered");
    }
    else {
      $('.intronav').removeClass('has_tag');
      $(".module").removeClass("filtered");
    }
    checkEmpty();
  });

  $("a.tag").on("click", function () {
    $(".filter_search input").val('');
    if ($(this).hasClass('all')) {
      $('.module').removeClass("filtered");
      $('.intronav').removeClass('has_tag');
    }
    else {
      var tag = $(this).attr("href").split("tag:").pop();
      $('.module').addClass("filtered");
      $('.intronav').addClass('has_tag');
      $('.module[data-tags*="' + tag + '"]').removeClass("filtered");
    }
    $("a.tag").removeClass("is_active");
    $(this).addClass("is_active");
    history.pushState(null, null, $(this).attr("href"));
    checkEmpty();
    return false;
  });

  function jobsFilter() {

    let url = $('body').data('url');

    $('.filter-select').each(function() {
      let filterSelect = this;
      let filter = filterSelect.dataset.filter;
      let filterValue = filterSelect.dataset.value;
      if(filterValue) {
        $('.module__job').each(function() {
          let job = this;
          let jobValue = $(job).data(filter);
          if(!jobValue.split(', ').includes(filterValue)) {
            $(job).addClass('filtered-' + filter);
          }
          else {
            $(job).removeClass('filtered-' + filter);
          }
        })
        url += '/' + filter + ':' + filterValue;
      }
      else {
        $('.module__job').each(function() {
          let job = this;
            $(job).removeClass('filtered-' + filter);
        })
      }
      history.pushState(null, null, url);
    })
    checkEmpty();
  }

  $(".filter-select__select").on("change", function () {
    let filterSelect = $(this).closest('.filter-select');
    let label = filterSelect.find(".filter-select__label span");
    let activeOption = filterSelect.find("option:selected");
    let value = activeOption.attr("value");
    if(value) {
      filterSelect.addClass('filter-select--active');
    }
    else {
      filterSelect.removeClass('filter-select--active');
    }
    label.text(activeOption.text());
    filterSelect.attr("data-value", value);
    jobsFilter();
    return false;
  });

  if($(".filter-select__select option:selected").length) {
    $(".filter-select__select").each(function() {
      this.dispatchEvent(new Event('change'));
    })
  }

  $(".t_fachbereiche .back").on("click", function () {
    $('.category_wrap').removeClass("da");
    $('.category_wrap').removeClass("is_active");
    $('.category_wrap.initial').addClass("da");
    $('aside').removeClass('has_tag');
    $(".t_fachbereiche .back").addClass('no_back');
    $('.facility_links').slideUp(250);
    history.pushState(null, null, $(this).attr("href"));
    return false;
  });

  $(".category_wrap").on("click", function (e) {
    if (!$(this).hasClass('is_active')) {
      if($(this).find('a.category').length) {
        var category = $(this).find('a.category').attr("href").split("kategorie:").pop();
        $('.category_wrap').removeClass("da");
        $('aside').addClass('has_tag');
        $('.category_wrap[data-category="' + category + '"]').addClass("da");
        $('.category_wrap').removeClass("is_active");
        $('.facility_links').not($(this).find('.facility_links')).slideUp(250);
        $(this).find('.facility_links').slideDown(250);
        $(this).addClass("is_active");
        history.pushState(null, null, $(this).find('a.category').attr("href"));
        $(".t_fachbereiche .back").removeClass('no_back');
      }
    }
    if ($(e.target).is(".sidebar .category_wrap") || $(e.target).parents(".sidebar .category_wrap").length) {
      if(!$(e.target).is(".facility_links") && !$(e.target).parents(".facility_links").length) {
        return false;
      }
    }
  });

  $("a.category").on("mouseover", function () {
    if ($(this).hasClass('all')) {
      $('.facility_wrap').removeClass("prefiltered");
    }
    else {
      var category = $(this).attr("href").split("kategorie:").pop();
      $('.facility_wrap').addClass("prefiltered");
      $('.facility_wrap[data-categories*="' + category + '"]').removeClass("prefiltered");
    }
  });
  $("a.category").on("mouseleave", function () {
    $('.facility_wrap').removeClass("prefiltered");
  });

  $('.slider').not('.s1').each(function () {
    tns({
      container: this,
      mouseDrag: true,
      swipeAngle: false,
      loop: false,
      rewind: true,
      controlsText: [
        '<svg width="30" height="40" viewBox="0 0 30 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.408579 19.6999L13.545 39.227L14.9652 38.1619L3.24889 20.5875L29.3442 20.5875L29.3442 18.8123L29.1667 18.8123L3.07137 18.8123L14.9652 1.41541L13.3675 0.350297L0.408579 19.6999Z" fill="white"/></svg>',
        '<svg width="30" height="40" viewBox="0 0 30 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.3915 19.7L16.255 0.172836L14.8349 1.23795L26.5512 18.8124H0.455811V20.5876H0.633331H26.7287L14.8349 37.9845L16.4326 39.0496L29.3915 19.7Z" fill="white"/></svg>'
      ],
      speed: 500
    });
  });
});

var pswpElement = document.querySelector('.pswp');
var lightboxGalleries = document.querySelectorAll('.lightbox_gallery');

for (var i = 0; i < lightboxGalleries.length; i++) {
  var lightboxGallery = lightboxGalleries[i];
  var lightboxLinks = lightboxGallery.querySelectorAll('a.lightbox');
  for (var j = 0; j < lightboxLinks.length; j++) {
    lightboxLinks[j].addEventListener('click', function (e) {
      openLightbox(lightboxGallery, this);
      e.preventDefault();
    });
  }
}

function openLightbox(lightboxGallery, clickedLightboxLink) {
  var index = 0;
  var items = [];
  var lightboxLinks = lightboxGallery.querySelectorAll('a.lightbox');
  for (var i = 0; i < lightboxLinks.length; i++) {
    var lightboxLink = lightboxLinks[i];
    if (lightboxLink == clickedLightboxLink) {
      index = i;
    }
    var image = lightboxLink.querySelector('img');
    var item = {
      src: lightboxLink.getAttribute('href'),
      w: lightboxLink.getAttribute('data-size').split('x')[0],
      h: lightboxLink.getAttribute('data-size').split('x')[1],
      msrc: lightboxLink.getAttribute('href'),
      el: image
    }
    item.title = image.getAttribute('alt');
    items.push(item);
  }
  var options = {
    index: index,
    bgOpacity: 0.9,
    showHideOpacity: true,
    fullscreenEl: false,
    zoomEl: false,
    shareEl: false,
    history: false,
    preload: [2, 2],
    getThumbBoundsFn: function (index) {
      var thumbnail = items[index].el;
      var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
      var rect = thumbnail.getBoundingClientRect();
      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
    }
  }
  var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
}

let cookiesUpdateButton = document.querySelector('a[href="#cookies"]');
if(cookiesUpdateButton) {
  cookiesUpdateButton.addEventListener('click', function(e) {
    const event = document.createEvent('HTMLEvents');
    event.initEvent('cookies:update', true, false);
    document.querySelector('body').dispatchEvent(event);
    e.preventDefault();
  });
}

document.body.addEventListener('cookies:saved', function(event) {
  if(event.detail.includes('analytics')) {
    window.location.reload();
  }
})

/* -------------------------------------------------- */
/* 🔢 Calculator */
/* -------------------------------------------------- */

let calculator = document.querySelector('.calculator');
if(calculator) {

  const fields = calculator.querySelectorAll('.calculator-field');
  const facilitySelect = calculator.querySelector('.calculator-field--facility-select select');
  const valuesContainers = calculator.querySelectorAll('.values');
  const elResultDay = calculator.querySelector('.result__day');
  const elResultMonth = calculator.querySelector('.result__month');

  // Initialize calculator

  const init = () => {
    fields.forEach(field => {

      // Check each first radio input
      const radioInput = field.querySelector('input[type="radio"]');
      if (radioInput) {
        radioInput.checked = true;
      }

      // Add data-attribute to each first values item
      valuesContainers.forEach(valuesContainer => {
        const valuesItem = valuesContainer.querySelector('.values__item');
        if (valuesItem) {
          valuesItem.dataset.active = true;
        }
      })

    })
  }

  init();

  // ----------------------------

  // Update facility values

  if (facilitySelect) {

    const updateFacilityValues = () => {
      const selectedValue = facilitySelect.value;

      // Loop through each values container
      valuesContainers.forEach(valuesContainer => {

        let values = valuesContainer.querySelectorAll('.values__item');
        let defaultValue = values[0];

        // Get the facility value based on the selected facility
        let facilityValue = valuesContainer.querySelector(`.values__item[data-facility="${selectedValue}"]`);

        // If a facility value exists
        if (facilityValue) {
          // Set all values to inactive
          values.forEach(value => value.dataset.active = false);
          // Set the facility value to active
          facilityValue.dataset.active = true;
        } else {
          // Set all values to inactive
          values.forEach(value => value.dataset.active = false);
          // Set the default value to active
          defaultValue.dataset.active = true;
        }
      });

      // Update the URL
      let urlParams = new URLSearchParams(window.location.search);
      urlParams.set('facility', selectedValue);
      history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());

    };

    // Add event listener for changes to facility select
    facilitySelect.addEventListener('change', function () {
      updateFacilityValues();
    });

    // Check if the URL has a facility
    let urlParams = new URLSearchParams(window.location.search);
    const facility = urlParams.get('facility');
    if (facility) {
      facilitySelect.value = facility;
    }

    // Initialise facility values
    updateFacilityValues();

  }

  // ----------------------------

  // Synchronization

  // Group the fields by synchronization group (data-sync)

  const groups = {};
  fields.forEach(field => {
    const group = field.dataset.sync;
    if (group) {
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(field);
    }
  });

  // Add event listeners to each group
  Object.keys(groups).forEach(group => {

    let fields = groups[group];
    
    fields.forEach(field => {

      let radioInputs = field.querySelectorAll('input[type="radio"]');

      // Add event listener and change every other radio input
      radioInputs.forEach(radioInput => {

        radioInput.addEventListener('change', function() {

          // Get the currently active radio input
          let activeRadioInput = field.querySelector('input[type="radio"]:checked');
          let activeRadioInputIndex = activeRadioInput.dataset.index;

          // Loop through the other fields
          fields.forEach(otherField => {

            // Skip the current field
            if(otherField === field) return;

            // Get the other radio inputs
            let otherRadioInputs = otherField.querySelectorAll('input[type="radio"]');

            // Loop through the other radio inputs
            otherRadioInputs.forEach(otherRadioInput => {

              // Get the index of the other radio input
              let otherRadioInputIndex = otherRadioInput.dataset.index;

              // Check if the other radio input is the currently active radio input
              if(otherRadioInputIndex === activeRadioInputIndex) {
                otherRadioInput.checked = true;
              }
              
              // It's not the currently active radio input
              else {

                // If we don't have enough radio inputs, check the last one
                if(parseFloat(activeRadioInputIndex) > otherRadioInputs.length && parseFloat(otherRadioInputIndex) === otherRadioInputs.length) {
                  otherRadioInput.checked = true;
                }

                // Otherwise, uncheck the other radio input
                else {
                  otherRadioInput.checked = false;
                }

              }

            })

          })

        })

      })

    })

  })

  // ----------------------------

  // Calculate

  const calculate = () => {

    let result = 0;

    // Loop through each field
    fields.forEach(field => {

      let selector = field;

      if(field.classList.contains('calculator-field--options')) {
        let activeOption = field.querySelector('input[type="radio"]:checked');
        if(!activeOption) return;
        selector = activeOption.closest('.option');
      }

      // Get the active value
      const activeValue = selector.querySelector('.values__item[data-active="true"]');

      if(activeValue) {
        
        result += parseFloat(activeValue.dataset.value ? activeValue.dataset.value : 0);

      }

    })

    // Format the result
    resultDay = result.toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    resultMonth = (result * 30.42).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    elResultDay.innerHTML = resultDay;
    elResultMonth.innerHTML = resultMonth;

  }

  calculate();

  fields.forEach(field => {
    field.addEventListener('change', calculate);
  });

}

const handleCustomSelect = (selectValue, selectInput) => {

  let activeOption = selectInput.querySelector('option[value="' + selectInput.value + '"]');
  
  if(activeOption) {
    selectValue.innerHTML = activeOption.textContent;
  }

}

const customSelects = document.querySelectorAll('.select');
customSelects.forEach(select => {

  const selectValue = select.querySelector('.select__value');
  const selectInput = select.querySelector('.select__input');

  handleCustomSelect(selectValue, selectInput);

  selectInput.addEventListener('change', () => {
    handleCustomSelect(selectValue, selectInput);
  });

});